import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { FC } from 'react';
import { EmbeddedAssetSwitch } from './EmbeddedAssetSwitch';
import { EmbeddedEntrySwitch } from './EmbeddedEntrySwitch';
import { Headings } from './Headings/';
import Hyperlink from './Hyperlink/Hyperlink';
import { Paragraph } from './Paragraph/';
// import { Bold } from './Bold/';
// import { Italic } from './Italic/';
// import { Underline } from './Underline/';
import { UnorderedList } from './UnorderedList/';
// import { OrderedList } from './OrderedList/';
import type { Sys } from 'src/types/contentful-sdk-compat';
import { CmsComponents } from 'src/lib/constants';
import { HorizontalRule } from './HorizontalRule/';
import { ListItem } from './ListItem/';

type CmsComponentName = (typeof CmsComponents)[keyof typeof CmsComponents];

// https://github.com/contentful/rich-text/tree/master/packages/rich-text-react-renderer
const RichTextRenderer: FC<{
  content: any; // TODO: this should be typed as `type { Document } from '@contentful/rich-text-types'` but requires fixing and validation of types throughout codebase
  nodes?: any;
  theme?: any;
  sys: Sys;
  /**
   * A first attempt at allowing parent components to fully define their rendering layer
   * without requiring CSS overrides or downstream conditionals. This is first
   * being used with `src/components-v3/Quote/Quote.tsx`. An alternative
   * inverted approach is to pass the parent content type down to rich
   * text components and allow them to perform internal switching.
   */
  contentTypeOverrides?: Partial<
    Record<CmsComponentName, FC<{ sys: Sys; fields: unknown }>>
  >;
}> = ({ content, nodes, theme = null, sys, contentTypeOverrides }) => {
  // Guard against rich text fields which aren't filled out
  if (!content?.content) {
    return null;
  }

  return (
    <>
      {documentToReactComponents(content, {
        renderMark: {
          // ...Bold(classes),
          // ...Italic(classes),
          // ...Underline(classes),
        },
        renderNode: {
          ...Hyperlink(nodes, sys),
          ...Paragraph(nodes, sys),
          // ...OrderedList(classes),
          ...UnorderedList(nodes),
          ...ListItem(nodes),
          ...Headings(nodes, sys),
          ...EmbeddedEntrySwitch(nodes, sys, contentTypeOverrides),
          ...EmbeddedAssetSwitch(nodes),
          ...HorizontalRule(nodes),
        },
        renderText: (text) => {
          return text.split('\n').reduce((children, textSegment, index) => {
            return [...children, index > 0 && <br key={index} />, textSegment];
          }, []);
        },
      })}
    </>
  );
};

export default RichTextRenderer;
